import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { CertificateActionResponse } from '@estercare/ester-shared'
import { theme } from '../../../theme/theme'
import { BodyLarge, BodyLargeMedium } from '../../../components/styles/Typography'
import { Womb } from '../../../components/icons/Womb'

type Props = {
  actions: CertificateActionResponse[]
}

export const NextStepsCard = ({ actions }: Props) => {
  const { t, i18n } = useTranslation()

  const stepsInLanguage = actions
    .filter((action) => action.language === i18n.language)
    .sort((a, b) => a.priority - b.priority)

  if (!stepsInLanguage.length) return null

  return (
    <Card>
      <BodyLargeMedium>{t('admin.certification.nextStepsTitle')}</BodyLargeMedium>
      <List>
        {stepsInLanguage.map((action) => (
          <ListItem key={action.text}>
            <Bullet>
              <Womb color={theme.color.plum} size={16} />
            </Bullet>
            <BodyLarge>{action.text}</BodyLarge>
          </ListItem>
        ))}
      </List>
    </Card>
  )
}

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.medium}px;
  background-color: ${theme.color.beigeLight};
  border-radius: ${theme.spacing.medium}px;
  padding: ${theme.spacing.large}px;
  margin-top: ${theme.spacing.xlarge}px;
  margin-bottom: ${theme.spacing.xxlarge}px;
`

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.mediumLarge}px;
`
const Bullet = styled.span`
  padding-top: 2px;
`

const ListItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${theme.spacing.small}px;
`
